// import { useEffect, useState } from 'react';
import { useState } from "react";
// import { useNavigate, Link } from "react-router-dom"; // Add Link import
import { Link } from "react-router-dom"; // Add Link import
import "../CSS/style.css";
import logo from "../images/genkaix.png";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  // const navigate = useNavigate(); // Fixed: lowercase 'navigate'

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // const goToPage = (path) => {
  //   navigate(path);
  //   toggleMenu(); // Close mobile menu
  // };

  return (
    // <header className={`header ${scrolled ? "scrolled" : ""}`}>
    <header className="header">
      <Link to="/" className="main-logo" onClick={() => toggleMenu()}>
        <img src={logo} alt="Genkaix Logo" />
      </Link>

      {/* 
      <nav className={`navbar ${menuOpen ? "active" : ""}`}>
        <i
          className={`fa  header-menu ${menuOpen ? "fa-arrow-left" : "fa-bars"}`}
          onClick={toggleMenu}
        />
        <ul>
          <li>
            <Link to="/" onClick={() => goToPage("/")}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={() => goToPage("/about")}>
              About
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={() => goToPage("/services")}>
              Services
            </Link>
          </li>
            <li>
            <Link to="/portfolio" onClick={() => goToPage("/portfolio")}>
              Portfolio
            </Link>
          </li>
          <li>
            <Link to="/career" onClick={() => goToPage("/career")}>
              Career
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => goToPage("/contact")}>
              Contact
            </Link>
          </li>
        
        </ul>
      </nav> */}

      <nav className={`navbar ${menuOpen ? "active" : ""}`}>
        <i
          className={`fa header-menu ${menuOpen ? "fa-arrow-left" : "fa-bars"}`}
          onClick={toggleMenu}
        />

        <ul>
          <li>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setMenuOpen(false)}>
              About
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={() => setMenuOpen(false)}>
              Services
            </Link>
          </li>
          <li>
            <Link to="/portfolio" onClick={() => setMenuOpen(false)}>
              Portfolio
            </Link>
          </li>
          <li>
            <Link to="/career" onClick={() => setMenuOpen(false)}>
              Career
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
